import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";

export const MessagesDisplayItemStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "messages-display-item",
})<{ $color: string }>`
  display: flex;
  font-weight: 400;
  font-size: 14px;
  padding: 4px;
  color: ${props => props.$color};
  svg {
    margin-inline-end: 10px;
    align-self: center;
    width: 15px;
  }
`;

export const MessagesDisplayContainerStyled = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "messages-display-container",
  },
)<{ $marginInlineStart?: string | undefined; $bgColor: string }>`
  background: ${props => props.$bgColor};
  margin-top: 5px;
  margin-bottom: 5px;
  padding-top: 7px;
  padding-bottom: 7px;
  border-radius: 3px;
  padding-inline-start: 7px;
  padding-inline-end: 3px;
  margin-inline-start: ${props =>
    props.$marginInlineStart ? props.$marginInlineStart : "0"};
  margin-inline-end: 0;
`;
